export default __webpack_public_path__ + "static/media/brazil-circle.05dc3455.png";